module.exports = __webpack_public_path__ + "img/title-1.0ade1c99.png";